<div class="credit-withdraw-content-container">
  <ng-container
    *ngIf="
      this._UserHelper.depositList != null &&
      this._UserHelper.depositList.length > 0 &&
      (this._DataHelper.selectedWallet.BranchType == 1 ? this._UserHelper.userInsicStatus === 1 || this._UserHelper.userInsicStatus === 2 : true)
    ">
    <div class="home-register" style="padding: 6px">
      <div class="text">
        {{ 'Deposit_InsicStatus1_text' | t }}
      </div>
      <!--<div class="button" [routerLink]="['/document']" style="padding: 12px">{{'MyAccount' | t}}</div>-->
    </div>
  </ng-container>
  <!-- *ngIf="depositList != null && depositList.length > 0" -->

  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 ? this._UserHelper.userInsicStatus === 1 || this._UserHelper.userInsicStatus === 2 : true">
    <div class="credit-input-container">
      <div class="deposit-text-container">
        {{ 'b3000_Withdraw_text_3_wa' | t }}
      </div>
      <inputb3
        [extraClass]="'amountInput'"
        fPlaceholder="{{ 'Amount' | t }}"
        fInputType="number"
        fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
        [(ngModel)]="amount"></inputb3>
    </div>
    <div class="payment-method-container">
      <div class="payment-method-row" *ngFor="let depositItem of this._UserHelper.depositList">
        <label for="deposit_{{ depositItem.DepositTypeId }}" style="display: flex; width: 100%">
          <div class="payment-left-side">
            <input type="radio" name="deposit-method" id="deposit_{{ depositItem.DepositTypeId }}" value="{{ depositItem.DepositTypeId }}" [(ngModel)]="paymentType" />
            <div class="trustly-icon">
              <ng-container
                *ngIf="
                  depositItem.DepositTypeId == 85 ||
                    depositItem.DepositTypeId == 21 ||
                    depositItem.DepositTypeId == 72 ||
                    depositItem.DepositTypeId == 91 ||
                    depositItem.DepositTypeId == 93;
                  else anotherdeposit
                ">
                <ng-container *ngIf="depositItem.DepositTypeId == 93; else noarenapay">
                  <image-loader-utils
                    [url]="depositItem.Description"
                    imageFormat="png"
                    extraClasses="icon payment-methods-icon arenapay"
                    altText="deposit_{{ depositItem.PaymentType }}"></image-loader-utils>
                </ng-container>
                <ng-template #noarenapay>
                  <image-loader-utils
                    [url]="depositItem.Description"
                    imageFormat="png"
                    extraClasses="icon payment-methods-icon"
                    altText="deposit_{{ depositItem.PaymentType }}"></image-loader-utils>
                </ng-template>
              </ng-container>
              <ng-template #anotherdeposit>
                <image-loader-utils [url]="depositItem.Description" extraClasses="icon payment-methods-icon" altText="deposit_{{ depositItem.PaymentType }}"></image-loader-utils>
              </ng-template>
            </div>
          </div>

          <div class="payment-right-side">{{ 'b3000_Min' | t }}. {{ depositItem.MinValue }}€</div>
        </label>
      </div>
    </div>

    <div class="deposit-limit-container">
      <div>
        <div class="row-initial">
          {{ 'b3000_Deposit_Text' | t }}
        </div>
        <div class="row-initial bold">
          {{ this._UserHelper.depositList[0]?.DescriptionLong }}
          {{ this._UserHelper.customerUser.Symbol }}
        </div>
        <div class="row-initial">
          {{ 'b3000_Deposit_Text2' | t }}
        </div>
      </div>
      <div class="go-setlimit-container" (click)="OpenAccountMobile(6)">
        {{ 'b3000_Deposit_Text3' | t }}
      </div>
    </div>

    <div class="confirm-button-container">
      <div class="alert-message" *ngIf="alertMessage">
        {{ alertMessageDesc }}
      </div>
      <ng-template #noAmount>
        <div class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | t }}</div>
        </div>
      </ng-template>
      <div *ngIf="amount >= 10 && paymentType; else noAmount" class="btn colored register-button save-changes-button confirm-button" (click)="wettArenaConfirmButton()">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </div>
    <div class="payment-sub-text">
      {{ 'b3000_Withdraw_text_2' | t }}
    </div>
  </ng-container>
  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (this._UserHelper.userInsicStatus === 0 || this._UserHelper.userInsicStatus === -2)">
    <div class="deposit-insicStatus-container">
      <div class="insicStatus-row">
        <p class="insicStatus-downtext">
          {{ 'b3000_Deposit_Text_5' | t }}
          <span class="underline-text" (click)="OpenAccountMobile(8)">
            {{ 'b3000_Deposit_Text_2' | t }}
          </span>
        </p>
      </div>
      <div class="insicStatus-row">
        <p class="insicStatus-downtext">
          {{ 'b3000_Deposit_Text_3' | t }}
        </p>
        <div class="btn colored register-button save-changes-button confirm-button green" (click)="OpenAccountMobile(8)">
          <div class="btn-text" style="color: #fff !important">
            {{ 'b3000_Deposit_Text_4' | t }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Bloked Customer 4 and -1 -->
  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (this._UserHelper.userInsicStatus === 4 || this._UserHelper.userInsicStatus === -1)">
    <div class="deposit-insicStatus-container">
      <div class="insicStatus-row">
        <p class="insicStatus-downtext" style="font-size: 16px; font-weight: 600">
          {{ 'b3000_Deposit_Text_6' | t }}
          <a [href]="'contactUrl' | getEnv" style="text-decoration: underline; color: #000; font-size: 16px; font-weight: 600">
            {{ 'b3000_Withdraw_Text_2' | t }}
          </a>
        </p>
      </div>
    </div>
  </ng-container>
</div>
